module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "修改头像",
      "width": "350px",
      "visible": _vm.formVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.formVisible = $event
      }
    }
  }, [_c('el-col', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "cont"
  }, [_c('div', [_c('img', {
    staticClass: "img",
    attrs: {
      "src": _vm.avatimgs
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "sels"
  }, [_c('input', {
    attrs: {
      "type": "file",
      "accept": "image/jpeg,image/jpg,image/png"
    },
    on: {
      "change": function($event) {
        return _vm.changeImg($event)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.formVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.formLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.formSubmit($event)
      }
    }
  }, [_vm._v("确认")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4cd9f635"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ruis/user/avatEdit.vue
// module id = 1167
// module chunks = 1